import * as ReusablePayerSetup from "./reusable-payer-setup"
import * as GatewaySetup from "./gateway-setup"
import * as OrdersFilters from "./orders-filters"
import * as _reports from "./reports"
import {CallJs} from "../lib/types";
import {CommandCaller} from "../lib/commands";
import * as legacy from "../legacy/modal"


export namespace admin {
	export const reusablePayerSetup = ReusablePayerSetup.reusablePayerSetupCallJs
	export const gatewaySetup = GatewaySetup
	export const ordersFilters = OrdersFilters.ordersFiltersCallJs
	export const reports = _reports
}

export namespace scheduledPayments {
	export const changeMethod = async (paymentSchedule: string, ajaxPage: string) => {
		console.log(ajaxPage);
		const cc = new CommandCaller(ajaxPage)
		try {
			const resp =
				await cc.runGet("scheduledPayments.changePaymentMethod", {
					paymentScheduleId: paymentSchedule
				}) as { content: string, title: string }

			console.log(resp)

			legacy.showDialog(
				"ChangePaymentsDialog",
				resp.title,
				resp.content,
				'420px'
			)
		} catch (e) {
			console.log("yuck", e)
		}
	}
}

export namespace front {
	export namespace update_cc {
		export const buildLink: CallJs<{ target: string, name: string }> = (cb, params) => {
			document.getElementsByName(params.name)
				.forEach(e => e.onclick = () => document.location.assign(params.target))
		}
		export const page: CallJs<{reference: string}> = (cb, params) => {
			const div = document.createElement('div')
			div.textContent = params.reference
			cb(div)
		}
	}
}



// WEBPACK FOOTER //
// ./src/orders2/orders2.tsx